export const IMPORT_INGREDIENT_FETCH_ERROR = 'IMPORT_INGREDIENT_FETCH_ERROR';
export const IMPORT_INGREDIENT_FETCHING = 'IMPORT_INGREDIENT_FETCHING';
export const IMPORT_INGREDIENT_FETCH_INGREDIENT_COLUMNS =
  'IMPORT_INGREDIENT_FETCH_INGREDIENT_COLUMNS';
export const IMPORT_INGREDIENT_SET_INGREDIENT_COLUMNS =
  'IMPORT_INGREDIENT_SET_INGREDIENT_COLUMNS';
export const IMPORT_INGREDIENT_CLEAR_ERROR = 'IMPORT_INGREDIENT_CLEAR_ERROR';
export const IMPORT_INGREDIENT_SET_PREVIEW_DATA =
  'IMPORT_INGREDIENT_SET_PREVIEW_DATA';
export const IMPORT_INGREDIENT_SET_SAVED_IMPORT_CONFIGS =
  'IMPORT_INGREDIENT_SET_SAVED_IMPORT_CONFIGS';
export const IMPORT_INGREDIENT_RESET_STATE = 'IMPORT_INGREDIENT_RESET_STATE';



// WEBPACK FOOTER //
// ./src/pages/importingredients/state/types.js